
<p-dialog
    [visible]="true"
    (visibleChange)="onCloseAction($event)"
    [closable]="closable"
    [draggable]="false"
    [modal]="true"
    [style]="{'min-width': '40vw', 'width': '991px', 'max-width': '90vw'}"
    styleClass="mx-3 mx-sm-0"
    [header]="headline?.length ? headline : '&nbsp;'"
>
    <div class="payment-cover">
        <img src="/assets/img/icons/payment-popup.svg" alt="payment main icon">
    </div>
    <div class="payment-content">
        <div class="row p-0 m-0">
            <div class="col-12 text-center sub-title p-0 m-0 mb-3" *ngIf="payment.price?.bgn">
                <h2 class="m-0 py-2">{{payment.description? payment.description + ' - ' : ''}}<span> {{payment.price?.bgn | price }}</span></h2>
            </div>

            <alert [type]="messageType" [message]="message" (remove)="message = ''"></alert>

        </div>

        <div class="row p-0 m-0">
            <div class="col-12 col-lg-10 text-center payments-wrap">

                <div id="paymentTabs" class="payment-tabs pt-4">
                    <div class="payment-tab">
                        <div class="row">
                            <div class="col-12">
                                <div class="collapse multi-collapse show" id="multiCollapseExample3" data-bs-parent="#paymentTabs">
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h2 class="my-2">
                                                <i class="icon-exchange"></i>
                                                {{ 'Плащане чрез онлайн трансфер' | transloco }}
                                            </h2>
                                        </div>

                                        <div class="col-12 flex-md-row flex-column d-flex justify-content-center align-items-center payment-buttons" [class.loading]="loading">
                                            <div class="mypos-button position-relative pay-btn my-3 mx-0 m-sm-3 d-flex justify-content-center align-items-center order-2 order-md-1" [class.loading]="loading" (click)="onBuyConfirmed($event)">
                                                <div class="fake-button text-md-center">
                                                    <i class="icon-card me-2"></i>
                                                    {{ 'С карта' | transloco }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="d-none" #form [innerHTML]="paymentForm | safe:'html'"></div>
    </div>
</p-dialog>
